import React from 'react';
import { defineMessages, useIntl } from 'react-intl-next';

import { Stack, xcss, Inline } from '@atlaskit/primitives';
import Heading from '@atlaskit/heading';

const i18n = defineMessages({
	rolePermissionsHeading: {
		id: 'default-space-permissions.set-role-modal.role-permissions-heading',
		defaultMessage: 'Select role permissions<asterisk>*</asterisk>',
		description: 'Heading for the input field where the user can enter the role permissions',
	},
});

const rolePermissionsHeadingStyle = xcss({
	paddingBottom: 'space.100',
});

export const SetRolePermissionsSection = ({
	asterisk,
}: {
	rolePermissions: string[];
	setRolePermissions: React.Dispatch<React.SetStateAction<string[]>>;
	asterisk: () => React.ReactNode;
}) => {
	const { formatMessage } = useIntl();

	return (
		<Stack>
			<Heading size="xsmall">
				<Inline xcss={rolePermissionsHeadingStyle}>
					{formatMessage(i18n.rolePermissionsHeading, {
						asterisk,
					})}
				</Inline>
			</Heading>
			todo
		</Stack>
	);
};
